import { Button } from "../../Atoms/Button";
import { Input } from "../../Atoms/Inputs/Input";
import { InputCheck } from "../../Atoms/Inputs/InputCheck";
import { InputCheckSlide } from "../../Atoms/Inputs/InputCheckSlide";
import { InputSwitch } from "../../Atoms/Inputs/InputSwitch";
import { Title } from "../../Atoms/Title";
import * as S from "./styles";
import { useProfilesDetail } from "./useProfilesDetail";

export const ProfilesDetailTemplate = () => {
  const {
    handleSubmit,
    register,
    handleSubmitForm,
    Controller,
    control,
    recursos,
    fields,
    handleChangeItem,
  } = useProfilesDetail();

  return (
    <S.Container>
      <S.Wrapper>
        <Title>Dados do Perfil</Title>

        <S.Form onSubmit={handleSubmit(handleSubmitForm)}>
          <div>
            <Controller
              control={control}
              name="ativo"
              render={({ field: { onChange, value } }) => (
                <InputSwitch
                  label={value ? "Ativo" : "Inativo"}
                  id="ativo"
                  checked={value}
                  onChange={(e) => onChange(e?.target?.checked)}
                />
              )}
            />
          </div>
          <div>
            <Input label="Nome" required {...register("nome")} />
          </div>

          <div>
            <p>Recursos</p>
          </div>

          <div>
            {recursos?.length > 0 &&
              recursos.map((r) => (
                <InputCheck
                  checked={fields?.some((i) => i?.value === r)}
                  text={r}
                  key={Math.random()}
                  onChange={() => handleChangeItem(r)}
                />
              ))}
          </div>

          <div>
            <Button>Salvar</Button>
          </div>
        </S.Form>
      </S.Wrapper>
    </S.Container>
  );
};
